export const PARTS = 'PARTS'
export const MESSAGES = 'MESSAGES'
export const PHOTOS = 'PHOTOS'
export const FILES = 'FILES'
export const TABS = [PARTS, MESSAGES, PHOTOS, FILES]
export const OVERVIEW_DATE_FORMAT = 'ddd, MMM Do YYYY [at] h:mm A'

export const attachmentsByProcess: {
    [type: string]: {
        title: string
        attachmentProcess: {
            attachmentType: string
            processType?: string
        }
    }
} = {
    fictiv5: {
        title: 'Inspection Documents',
        attachmentProcess: {
            attachmentType: 'fictiv5',
        },
    },
    inspection_Photos: {
        title: 'Inspection Photos',
        attachmentProcess: {
            attachmentType: 'photos',
        },
    },
    additional_Docs: {
        title: 'Additional Documents',
        attachmentProcess: {
            attachmentType: 'additional-docs',
        },
    },
    'Certificate of Conformity': {
        title: 'Certificate of Conformity',
        attachmentProcess: {
            attachmentType: 'certificate_of_conformance',
            processType: 'certification',
        },
    },
    'Material Certification': {
        title: 'Material Certification',
        attachmentProcess: {
            attachmentType: 'material_certification',
            processType: 'certification',
        },
    },
    'Advanced Inspection Report': {
        title: 'Advanced Inspection Report',
        attachmentProcess: {
            attachmentType: 'advanced_inspection',
            processType: 'inspection',
        },
    },
}

export const CERTIFICATION_INSPECTION_POST_PROCESSES = [
    'certificate-of-compliance',
    'material-certification',
    'advanced-inspection',
]

export const ATTACHMENT_TYPE = {
    PHOTOS: 'photos',
    ADDITIONAL_DOCS: 'additional-docs',
    FICTIV5: 'fictiv5',
    CERTIFICATE_OF_CONFORMANCE: 'certificate_of_conformance',
    MATERIAL_CERTIFICATION: 'material_certification',
    ADVANCED_INSPECTION: 'advanced_inspection',
}
